import { createAsyncThunk } from "@reduxjs/toolkit";
import loginProps from "../core/types/auth";
import Api from "../core/api/api";
import axiosInstance from "../core/interceptor/http-interceptor-config";

export const loginApi = createAsyncThunk(
  "auth/loginApi",
  async (loginObj: loginProps) => {
    return await axiosInstance.post(`${Api.login}`, loginObj);
  }
);

export const logoutApi = createAsyncThunk(
  "auth/logoutApi",
  async (logoutObj: any) => {
    return await axiosInstance.post(`${Api.logout}`, logoutObj);
  }
);

export const userApi = createAsyncThunk("auth/user", async () => {
  return await axiosInstance.get(`${Api.user}`);
});

export const userNotifications = createAsyncThunk(
  "auth/userNotifications",
  async (pageNo: number) => {
    return await axiosInstance.get(Api.notifications + "?page=" + pageNo);
  }
);

export const readUserNotification = createAsyncThunk(
  "auth/readUserNotification",
  async (id: number) => {
    return await axiosInstance.post(Api.notifications + id + "/read/");
  }
);